import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import InstructionsIcon from '@assets/icons/instructions.svg?component';
import type { InfoDialogProps } from './InstallationStep.types';
import CloseIcon from '@mui/icons-material/Close';

export const InfoDialog = ({ open, description, onClose }: InfoDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth variant="warning">
      <IconButton
        onClick={onClose}
        aria-label="close"
        size="small"
        sx={{ position: 'absolute', top: 12, right: 12 }}
      >
        <CloseIcon variant="infoDialogCloseIcon" />
      </IconButton>

      <DialogContent sx={{ p: '24px 72px' }}>
        <Stack alignItems="center" sx={{ py: 2 }}>
          <Box sx={{ mt: '40px' }}>
            <SvgIcon component={InstructionsIcon} sx={{ width: '101px', height: '150px' }} viewBox="0 0 101 150" />
          </Box>

          <Typography
            variant="title.dialog"
            textAlign="center"
            mt="24px"
            className="InfoDialog-title"
          >
            Installation Information
          </Typography>

          <Typography variant="body.md" textAlign="center" mt="20px">
            {description}
          </Typography>

          <Stack direction="row" gap="15px" mt="27px">
            <Button variant="contained" onClick={onClose}>
              Confirm
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
